import { cn } from '@core/utils'

const DialogHeader = ({ className, ...props }: React.ComponentProps<'div'>) => {
    return (
        <div
            data-slot="dialog-header"
            className={cn(
                'flex flex-col gap-2 text-center sm:text-left',
                className,
            )}
            {...props}
        />
    )
}

DialogHeader.displayName = 'DialogHeader'

export default DialogHeader
